/**
 * @file buttonLabels.ts
 * @description
 * -----------------------------------------------------
 * Constantes para las etiquetas de botones
 * -----------------------------------------------------
 * @version 0.0.1a
 * @created 2025-08-27
 * @modified 2025-11-18
 * @author Correcta
 * @author Mohammed Derfoufi
 * @modified Sergio Manjón
 * @copyright © Correcta
 * @license Private
 * */

/**
 * Constantes para las etiquetas de botones utilizadas en la aplicación
 */
export const BUTTON_LABELS = {
  VERIFY: "buttonVerify",
  SUBMIT: "buttonSubmit",
  SEARCH: "buttonSearch",
  CHATBOT: "buttonChatBot",
  GENERATE_REPORT_DASHBOARD: "buttonGenerateNewReport",
  GENERATE_NEW_REPORT: "buttonGenerateNewReport",
  DOWNLOAD_FILE: "buttonDownloadFile",
  CANCEL: "buttonCancel",
  ASIGN: "buttonConfirmAsign",
  REQUEST_LICENSE: "buttonRequestLicense",
  ACCEPT: "buttonAccept",
  CONTINUE: "buttonContinue",
  ADD: "buttonAdd",
  ADD_CAMPAIGN: "buttonAddCampaign",
  EDIT: "buttonEdit",
  REJECT_CHANGES: "buttonRejectUpgrades",
  BACK_LICENSES: "buttonBackLicenses",
  ACCEPT_COOKIES: "buttonAcceptCookies",
  REJECT_COOKIES: "buttonRejectCookies",
  MANAGE_COOKIES: "buttonManageCookies",
  BACK: "buttonBack",
  YES: "buttonYes",
  NO: "buttonNo",
  LOADING: "buttonLoading",
  ADVANCED_SEARCH: "buttonAdvancedSearch",
  EDIT_PROFILE: "buttonEditProfile",
  DETAILS: "buttonDetails",
  CHANGE_PASSWORD: "buttonChangePassword",
  FAKE_IMAGE: "buttonFakeImage",
  HELP: "buttonHelp",
  CONFIRM: "buttonConfirm",
  SELECT_DATE: "buttonSelectDate",
  JUMP_TO_CONTENT: "buttonJumpToContent",
  CLOSE_MENU: "buttonCloseMenu",
  REFRESH: "buttonRefresh",
  EDIT_IMAGE: "buttonEditImage",
  UPLOAD_FILE: "buttonUploadFile",
  CLOSE: "buttonClose",
  REMOVE_USERS: "buttonRemoveUsers",
  INVITE_USERS: "buttonInviteUsers",
  ADD_USERS: "buttonInviteUsers",
  CREATE_USERS: "buttonCreateUsers",
  CREATE: "buttonCreate",
  ANALYSE_REPOSITORIES: "buttonAnalyseRepositories",
  CONFIRM_SELECT: "buttonConfirmSelect",
  LOGIN: "buttonLogin",
  SEND: "buttonSend",
  DECREMENT: "buttonDecrement",
  INCREMENT: "buttonIncrement",
  FIELD: "buttonField",
  BLOCKED: "buttonBlocked",
  MANAGE_LICENSES: "buttonManageLicenses",
  SEE: "buttonSee",
  FULLSCREEN: "buttonFullscreen",
  TOGGLE_MENU: "buttonToggleMenu",
  SEND_MESSAGE: "buttonSendMessage",
  SHOW_PASSWORD: "buttonShowPassword",
  HIDE_PASSWORD: "buttonHidePassword",
  GRAPH_ARIA_LABEL: "buttonGraphAriaLabel",
  ADD_TO_REPORT: "buttonAddToFile",
  PEAK_ACTIVITY: "buttonPeakActivity",
  SAVE_FILTERS: "buttonSaveFilters",
  UPDATE: "buttonUpdate",
  UPDATE_FILTER: "buttonUpdateFilter",
  SELECT_INFORM: "buttonSelectInform",
  ADD_APIKEY: "buttonAddApiKey",
  SAVE: "buttonSave",
  VALIDATE_CODE: "buttonValidateCode",
  EDIT_GROUP: "buttonEditGroup",
  NO_INTEREST_WORDS: "buttonNoInterestWords",
  SELECT_LANGUAGE: "buttonSelectLanguage",
  IMPORT_CAMPAIGN: "buttonImportCampaign",
  ADVANCED_FILTER: "buttonAdvancedFilter",
  RESET_FILTERS: "buttonResetFilters",
  ANALYZE: "buttonAnalyze",
  VIEW_CAMPAIGNS: "buttonViewCampaigns",
  ACCESS: "buttonAccess",
  VIEW_INFO: "buttonViewInfo",
};
